const utils = (storeUtils = window.flex) => {

    const { getStore } = storeUtils;

    function validatePassword(password) {
        const store = getStore();
        var passwordConfig = store.appContext.app.passwordConfig;
        var isValid = true;

        if (password !== "" && password != undefined && password != null) {
            //Regex for lower case letters
            const lowercaseLetter = /[a-z]/;
            //Regex for upper case letters
            const uppercaseLetter = /[A-Z]/;
            //Regex for digits
            const digits = /[0-9]/;
            //Regex for nonalphanumeric within ascii range (00 - 127)
            const nonalphaNumeric = /(?=\W)(?=[\x00-\x7F])/;
            //Regex for unicode characters outside of ascii (00 - 127)
            const unicode = /[^\x00-\x7F]/;
            var characterTypeRegexes = [lowercaseLetter, uppercaseLetter, digits, nonalphaNumeric, unicode];
            var characterTypeCount = 0;
            var passwordErrorMsg = "";

            //As a side note, some unicode characters are actually longer
            if (password.length < passwordConfig.minimumPasswordLength) {
                passwordErrorMsg = passwordErrorMsg.concat(`Password must be at least ${passwordConfig.minimumPasswordLength} characters\n`);
                isValid = false;
            }

            //Checking for character types.  Better way to do this?
            for (var i = 0; i < characterTypeRegexes.length; i++) {
                if (characterTypeRegexes[i].test(password)) {
                    characterTypeCount++;
                }
            }

            if (characterTypeCount < passwordConfig.minimumCharacterTypes) {
                passwordErrorMsg = passwordErrorMsg.concat(`Password must include at least ${passwordConfig.minimumCharacterTypes} of the following classes: UPPER or lower case letters, numbers or special characters\n`);
                isValid = false;
            }

            //For some reason, returning a blank string is still an "error", so it goes red. So we get to do this.
            if (isValid) {
                return true;
            }
            return passwordErrorMsg;
        }
        return true;
    }

    return {
        validatePassword
    };
}

module.exports = utils;